module.exports = __webpack_public_path__ + "img/icon-key.a43608cd.svg";